export const discoverSitecoreQuickAction = {
  type: 'ui',
  name: 'Discover Sitecore',
  displayName: { name: 'Sitecore’s YouTube channel' },
  icon: {
    type: 'mdi',
    src: 'mdiTelevisionPlay',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://www.youtube.com/c/DiscoverSitecore/?utm_source=cloud-portal&utm_medium=help-section',
  },
};
